export const education = {
  degree: "B.E in Computer Science & Engineering",
  institution: "Dhanalakshmi Srinivasan College of Engineering and Technology (Anna University)",
  location: "Tamil Nadu, India",
  period: "2021 — 2025",
  detail: "CGPA: 7.48",
};

export const achievements = [
  "Participated in Ideation Challenge 2025 at DSCET — presented an innovative tech solution concept.",
  "Solved 40+ Data Structures & Algorithms problems on LeetCode, demonstrating strong problem-solving skills.",
];
